import classes from './Footer.module.scss';
import logo from '../../assets/images/logoWhite.svg';
import { Space, Typography } from 'antd';
import Container from '../UI/Container/Container';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <div className={classes.footer} id='footer'>
      <Container>
        <div className={classes.body}>
          <div className={classes.logoColumn}>
            <a href='/'>
              <img src={logo} alt='logo' className={classes.logo} />
            </a>
            <Space direction='vertical' className={classes.footer__copyring}>
              <Typography className={classes.secondaryText}>
                © 2021–{new Date().getFullYear()} TigSiPay SIA. {'\n'}
                <span>{t('footer.allRightsReserved')}</span>
              </Typography>
            </Space>
          </div>
          <div className={classes.menu}>
            <div className={classes.menu__column}>
              <Typography className={classes.menu__subtitle}>
                {t('footer.business')}
              </Typography>
              <a
                rel='noreferrer'
                href={t('links.loyaltyProgram')}
                className={classes.menu__item}
              >
                {t('footer.loyaltyProgram')}
              </a>
              <a
                rel='noreferrer'
                href={t('links.mobileApp')}
                className={classes.menu__item}
              >
                {t('footer.mobileApp')}
              </a>
              <a
                rel='noreferrer'
                href={t('links.solutionsForShops')}
                className={classes.menu__item}
              >
                {t('footer.solutionsForShops')}
              </a>
              <a
                rel='noreferrer'
                href={t('links.becomePartner')}
                className={classes.menu__item}
              >
                {t('footer.becomePartner')}
              </a>
            </div>
            <div className={classes.menu__column}>
              <Typography className={classes.menu__subtitle}>
                {t('footer.individuals')}
              </Typography>
              <a
                rel='noreferrer'
                href={t('links.billPayment')}
                className={classes.menu__item}
              >
                {t('footer.billPayment')}
              </a>
              <a
                rel={t('links.partnerShops')}
                href='/'
                className={classes.menu__item}
              >
                {t('footer.partnerShops')}
              </a>
              <a
                rel='noreferrer'
                href={t('links.serviceProviders')}
                className={classes.menu__item}
              >
                {t('footer.serviceProviders')}
              </a>
              <a
                rel='noreferrer'
                href={t('links.topupCodes')}
                className={classes.menu__item}
              >
                {t('footer.topupCodes')}
              </a>
            </div>
            <div className={classes.menu__column}>
              <div className={classes.menu__column} style={{ width: '100%' }}>
                <Typography className={classes.menu__subtitle}>
                  {t('footer.aboutUs')}
                </Typography>
                <a
                  rel='noreferrer'
                  href={t('links.aboutCompany')}
                  className={classes.menu__item}
                >
                  {t('footer.aboutCompany')}
                </a>
                <a
                  rel='noreferrer'
                  href={t('links.contact')}
                  className={classes.menu__item}
                >
                  {t('footer.contact')}
                </a>
                <a
                  rel='noreferrer'
                  href={t('links.contactUs')}
                  className={classes.menu__item}
                >
                  {t('footer.contactUs')}
                </a>
              </div>
              <div
                className={classes.menu__column}
                style={{ marginTop: 20, width: '100%' }}
              >
                <Typography className={classes.menu__subtitle}>
                  {t('footer.news')}
                </Typography>
                <a
                  rel='noreferrer'
                  href={t('links.blog')}
                  className={classes.menu__item}
                >
                  {t('footer.blog')}
                </a>
              </div>
            </div>
            <div className={classes.menu__column}>
              <Typography className={classes.menu__subtitle}>
                {t('footer.documents')}
              </Typography>
              <a
                rel='noreferrer'
                href={t('links.legal')}
                className={classes.menu__item}
              >
                {t('footer.legal')}
              </a>
            </div>
          </div>
          <div className={classes.menu__contacts}>
            <div className={classes.menu__column} style={{ width: '100%' }}>
              <Typography className={classes.menu__subtitle}>
                {t('footer.contact')}
              </Typography>
              <Typography
                className={`${classes.menu__item} ${classes.secondaryText}`}
                style={{ lineHeight: '18.75px', letterSpacing: '.005em' }}
              >
                TigSiPay SIA
                <br />
                <span>Reg. No. 40203344731</span>
                <br />
                <span>Skanstes iela 7 k-1, Rīga, LV-1013 </span>
                <a
                  className={`${classes.menu__item} ${classes.secondaryText}`}
                  style={{
                    lineHeight: '18.75px',
                    letterSpacing: '.005em',
                    textDecoration: 'underline'
                  }}
                  href='mailto:info@tigsipay.com'
                >
                  info@tigsipay.com
                </a>
                <br />
                <br />
                <span>{t('footer.vat')}: LV40203344731</span>
                <br />
                <br />
                <span>
                  {t('footer.phone')}:{' '}
                  <a
                    href='tel:+37120757800'
                    className={`${classes.menu__item} ${classes.secondaryText}`}
                    style={{
                      lineHeight: '18.75px',
                      letterSpacing: '.005em',
                      textDecoration: 'underline'
                    }}
                  >
                    +371 20757800
                  </a>
                </span>
              </Typography>
            </div>
            <div className={classes.contacts}>
              <Typography className={classes.menu__subtitle}>
                {t('footer.followUs')}
              </Typography>
              <div className={classes.networks}>
                <a
                  href='https://www.instagram.com/tigsi_pay/'
                  target='_blank'
                  rel='noreferrer'
                >
                  <img src='/icons/instagram.svg' alt='instagram' />
                </a>
                <a
                  href='https://www.facebook.com/TigsiPay'
                  target='_blank'
                  rel='noreferrer'
                >
                  <img src='/icons/facebook.svg' alt='facebook' />
                </a>
                <a
                  href='https://www.linkedin.com/company/tigsipay/'
                  target='_blank'
                  rel='noreferrer'
                >
                  <img src='/icons/linkedIn.svg' alt='linked in' />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div>
          <Typography
            className={`${classes.secondaryText} ${classes['footer__ps']}`}
            style={{ letterSpacing: '.005em', lineHeight: '18.75px' }}
          >
            {t('footer.text')}
          </Typography>
        </div>
        <Space
          direction='vertical'
          className={classes['footer__copyring--mob']}
        >
          <Typography className={classes.secondaryText}>
            © 2021–{new Date().getFullYear()} TigSiPay SIA. {'\n'}
            <span>{t('footer.allRightsReserved')}</span>
          </Typography>
        </Space>
      </Container>
    </div>
  );
};

export default Footer;
